import {
  AmplifyGet,
  AmplifyPost,
} from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import {
  CreatePersonaInquiryResponse,
  PersonaInquiryStatusResponse,
} from "../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { logger } from "providers/logger";

type CreatePersonaInquiryParams = {
  prospectId: string;
  proposalId: string;
  contactId: string;
  hybridToken?: string;
  firstName?: string;
  lastName?: string;
  birthdate?: string;
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  inquiryType?: "verify" | "link";
};

const createPersonaInquiry = async ({
  prospectId,
  proposalId,
  contactId,
  hybridToken,
  firstName,
  lastName,
  birthdate,
  street,
  city,
  state,
  postalCode,
  inquiryType,
}: CreatePersonaInquiryParams): Promise<CreatePersonaInquiryResponse> => {
  if (!hybridToken) {
    throw new Error("Missing auth token for Persona inquiry creation");
  }

  return await AmplifyPost<CreatePersonaInquiryResponse>(
    "Create Persona Inquiry",
    "OfferExpApi",
    `/prospect/${prospectId}/proposals/${proposalId}/persona-inquiry`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      body: {
        contactId,
        firstName,
        lastName,
        birthdate,
        street,
        city,
        state,
        postalCode,
        ...(inquiryType ? { inquiryType } : {}),
      },
    },
    logger
  );
};

type GetPersonaInquiryStatusParams = {
  prospectId: string;
  proposalId: string;
  contactId: string;
  hybridToken?: string;
};

const getPersonaInquiryStatus = async ({
  prospectId,
  proposalId,
  contactId,
  hybridToken,
}: GetPersonaInquiryStatusParams): Promise<PersonaInquiryStatusResponse> => {
  if (!hybridToken) {
    throw new Error("Missing auth token for Persona inquiry status");
  }

  return await AmplifyGet<PersonaInquiryStatusResponse>(
    "Get Persona Inquiry Status",
    "OfferExpApi",
    `/prospect/${prospectId}/proposals/${proposalId}/persona-inquiry?contactId=${encodeURIComponent(
      contactId
    )}`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
    },
    logger
  );
};

export { createPersonaInquiry, getPersonaInquiryStatus };
